"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _LayoutModule = _interopRequireDefault(require("../styles/components/Layout.module.css"));
var _reactRouterDom = require("react-router-dom");
var _PAUL_Logo_blue = _interopRequireDefault(require("../images/PAUL_Logo_blue.svg"));
var _PAUL_Logo_white = _interopRequireDefault(require("../images/PAUL_Logo_white.svg"));
var _UserPanel = _interopRequireDefault(require("./UserPanel"));
var _constants = require("../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Layout wrap with user panel
 * @param {JSX.Element}  children Site content
 * @param {boolean} isLogin Flag, if true - logo and user panel will be hidden
 * @param {string} marginBottom indent at the bottom of the panel
 * @param {string} theme The theme of site (temporary), can be all variant from themeKey
 *
 * @returns {JSX.Element}
 *
 * @public
 */

const Layout = _ref => {
  let {
    children,
    isLogin = false,
    marginBottom = '170px',
    theme = _constants.defaultTheme
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Navbar, {
    expand: "lg",
    className: "py-40 ".concat(_LayoutModule.default.navbar, " ").concat(_LayoutModule.default.layout)
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    className: _LayoutModule.default.container
  }, !isLogin ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Navbar.Brand, {
    className: 'user-select-none'
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: theme === _constants.themeKey.light ? _PAUL_Logo_blue.default : _PAUL_Logo_white.default,
    alt: "PAUL"
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Navbar.Collapse, {
    className: "justify-content-end"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Navbar.Text, null, /*#__PURE__*/_react.default.createElement(_UserPanel.default, {
    theme: theme
  })))) : null)), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: marginBottom
    }
  }, /*#__PURE__*/_react.default.createElement("main", null, children)));
};
var _default = exports.default = Layout;